import {
  Create,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  TextInput,
  SimpleForm,
  FileInput,
  FileField,
  useRedirect,
  useNotify,
} from "react-admin";
export default function AlbumCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput label="Album Name" source="name"></TextInput>
        <ReferenceArrayInput
          label="Artist"
          reference="artists"
          source="Artist_ids">
          <AutocompleteArrayInput
            onCreate={() => {
              // const newTagName = prompt("Enter a new tag");
              // const newTag = { id: newTagName.toLowerCase(), name: newTagName };
              // return newTag;
            }}
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  );
}
